/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { createLogger } from '../services/LoggerService';

const log = createLogger('SessionStorageAccess');

export const getSessionStorage = (key: string): string | null | undefined => {
  try {
    return window.sessionStorage.getItem(key);
  } catch (error) {
    // we don't want to capture this with Sentry
    log.warn(`Failed to read "${key}" from sessionStorage`, error);
    return undefined;
  }
};

export const setSessionStorage = (key: string, value: string): void => {
  try {
    window.sessionStorage.setItem(key, value);
  } catch (error) {
    // we don't want to capture this with Sentry
    log.warn(`Failed to write "${key}" to sessionStorage`, error);
  }
};
export const removeSessionStorage = (key: string): void => {
  try {
    window.sessionStorage.removeItem(key);
  } catch (error) {
    // we don't want to capture this with Sentry
    log.warn(`Failed to remove "${key}" from sessionStorage`, error);
  }
};
export const clearSessionStorage = (): void => {
  try {
    window.sessionStorage.clear();
  } catch (error) {
    // we don't want to capture this with Sentry
    log.warn(`Failed to clear sessionStorage`, error);
  }
};
